import { Grid2 as Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import Radio from '@mui/material/Radio';
import React from "react";
import useDebugInformation from "../../../../../../../../../../hooks/useDebugInformation";
import { StateKeys } from "@services/storage/storeTemplate";
import { useAppSelector } from "@store/hooks";
import { QuestionObject } from "@utils/questions";

type RadioProps = {
    options: QuestionObject
    handleChange: (event: React.ChangeEvent<HTMLInputElement>, value: any) => void
    sx: any
}

const RadioSelect: React.FC<RadioProps> = ({ options, handleChange, sx }) => {
    const value = useAppSelector<string>(state => state.state[`RequiredOption${options.id + 1}Answer` as StateKeys])
    useDebugInformation("Radios", { options, handleChange })

    const isInOptions = React.useMemo(() => value && options.options.some(option => option.text === value), [value, options]);

    return (
        (<Paper sx={sx} elevation={4}>
            <Grid
                size={{
                    xs: 12,
                    sm: 12
                }}>
                <FormControl component="fieldset">
                    <FormLabel component="legend" sx={{
                        maxWidth: "80ch",
                        wordWrap: "break-word",
                    }}>{options.question}</FormLabel>
                    <RadioGroup aria-label={options.question.toLowerCase()} name={options.question} value={value || null} onChange={handleChange}>
                        {options.options.map((option, i: number) =>
                            <FormControlLabel key={options.question.toLowerCase().replaceAll(" ", "_") + i} value={option.text === "Other" && !isInOptions ? value : option.text} control={<Radio />} label={option.text !== "Other" ? option.text
                                : <TextField size='small' label="Other" value={value !== "Other" && !isInOptions ? value : ""} onChange={(event) => {
                                    handleChange(event as React.ChangeEvent<HTMLInputElement>, event.target.value)
                                }} />} />
                        )}
                    </RadioGroup>
                </FormControl>
            </Grid>
        </Paper>)
    );
}

export default React.memo(RadioSelect)